'use strict';

angular.module('amexReconciliationApp')
  .component('helpModal', {
    templateUrl: 'scripts/views/modals/help-modal.html',
    bindings: {
      closeModalCallback: '&'
    },
    controller: function (UserModel, 
                          FeatureFlagModel, 
                          HelpFileRepository,
                          languages) {

      var self = this;

      self.$onInit = function () {
        self.closeModal = self.closeModalCallback;
        self.displayLanguageSelection = FeatureFlagModel.languageFlag;
        self.languages = languages;
        self.selectedLanguage = UserModel.currentUserPreferences().language;
        self.helpFiles = [];

        getHelpFileList();
      };

      self.changeLanguage = function () {
        getHelpFileList();
      };

      self.getFileUrl = function (fileName) {
        return '/api/v1/help-file/' + self.selectedLanguage + '/' + sanitize(fileName) + '/';
      };

      function sanitize(fileName) {
          return _.replace(fileName, '#', '%23');
      }

      function getHelpFileList() {
        HelpFileRepository.getHelpFileList(self.selectedLanguage)
          .then(function (response) {
            self.helpFiles = _.sortBy(response.helpFiles, 'date');
          })
          .catch(function () {
            self.helpFiles = [];
          });
      }
    }
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/helpModal.js
// module id = 451
// module chunks = 0